import React from "react";

function SvgIcMapPoi124(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M9.5 22a1.5 1.5 0 110 3h-2a1.5 1.5 0 110-3h2zm15 0a1.5 1.5 0 110 3h-3a1.5 1.5 0 110-3h3zM16 14.003a1 1 0 01.993.883l.007.117V21h1a1.5 1.5 0 01.145 2.993L18 24h-4.5a1.5 1.5 0 01-.144-2.994L13.5 21H15v-5.997a1 1 0 011-1zm6-7.02l3.034 3.016L22 13.016 21.977 13H10c-.51 0-.935-.388-.993-.883L9 12V8.002c0-.51.388-.935.884-.993L10 7.002h11.972l.028-.02z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi124;
